module.exports = __webpack_public_path__ + "static/cmc-d0920e13638bd982d30e618a45415a9f.jpg";